import Header from "@/components/Header";
import Footer from "@/components/Footer";

const AvisoLegal = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto max-w-3xl px-4 py-32">
        <h1 className="font-display text-3xl font-bold sm:text-4xl">Aviso Legal</h1>

        <section className="mt-8 space-y-4 text-muted-foreground">
          <h2 className="text-xl font-semibold text-foreground">1. Datos identificativos</h2>
          <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
            Información y Comercio Electrónico (LSSI-CE), se informa al usuario de que el titular de este sitio web
            es <strong className="text-foreground">Null Guard</strong>, con domicilio social en España y correo
            electrónico de contacto: <a href="mailto:info@nullguard.xyz" className="text-primary hover:underline">info@nullguard.xyz</a>.
          </p>

          <h2 className="text-xl font-semibold text-foreground">2. Objeto</h2>
          <p>
            Este sitio web tiene como finalidad informar sobre los servicios de formación en ciberseguridad ofrecidos
            por Null Guard, así como facilitar el contacto con potenciales clientes.
          </p>

          <h2 className="text-xl font-semibold text-foreground">3. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos de este sitio web, incluyendo textos, imágenes, logotipos, gráficos, iconos y
            software, son propiedad de Null Guard o de sus respectivos titulares y están protegidos por las leyes
            españolas e internacionales de propiedad intelectual e industrial.
          </p>
          <p>
            Queda prohibida su reproducción, distribución, comunicación pública o transformación, total o parcial,
            sin la autorización expresa y por escrito de Null Guard.
          </p>

          <h2 className="text-xl font-semibold text-foreground">4. Responsabilidad</h2>
          <p>
            Null Guard no se hace responsable de los daños o perjuicios que pudieran derivarse del acceso o uso de
            este sitio web, incluyendo errores u omisiones en los contenidos, falta de disponibilidad del sitio o
            transmisión de virus o programas maliciosos.
          </p>

          <h2 className="text-xl font-semibold text-foreground">5. Enlaces externos</h2>
          <p>
            Este sitio web puede contener enlaces a sitios de terceros. Null Guard no se responsabiliza del contenido
            ni de las prácticas de privacidad de dichos sitios.
          </p>

          <h2 className="text-xl font-semibold text-foreground">6. Legislación aplicable</h2>
          <p>
            Las presentes condiciones se rigen por la legislación española. Para cualquier controversia, las partes
            se someterán a los Juzgados y Tribunales del domicilio del usuario, de acuerdo con la normativa vigente.
          </p>
        </section>

        <nav aria-label="Otras páginas legales" className="mt-12 flex flex-wrap gap-4 border-t border-border pt-8 text-sm">
          <a href="/politica-de-privacidad" className="text-primary hover:underline">Política de privacidad</a>
          <a href="/accesibilidad" className="text-primary hover:underline">Declaración de accesibilidad</a>
        </nav>
      </main>
      <Footer />
    </div>
  );
};

export default AvisoLegal;
